<div class="page-content">
  <div class="container">
    {{ "DIRECT_TO_NEW_PAGE" | translate }}
  </div>
</div>
